<template>
  <div>
    <a-row :gutter="30">
      <a-col :span="14">
        <div class="item-title fixed">
          我的佣金
          <span class="pull-right">
            <a-button type="primary" size="small" shape="round" @click="showWithdrawModal">我要提现</a-button>
          </span>
        </div>
        <div class="stat-box">
          <div class="item primary">
            <div class="content">
              <div class="process " :style="{height: commissionRateHeight[0] +'px'}"></div>
              <div class="bottom">
                <div class="value"><span class="small">￥</span> {{commission.total_commission}}</div>
                <div class="label">累计佣金</div>
              </div>
            </div>
          </div>
          <div class="item success">
              <div class="content">
                <div class="process " :style="{height: commissionRateHeight[1] +'px'}"></div>
                <div class="bottom">
                  <div class="value"><span class="small">￥</span> {{commission.commission}}</div>
                  <div class="label">可提现</div>
                </div>
              </div>
          </div>
          <div class="item error">
            <div class="content">
              <div class="process "  :style="{height: commissionRateHeight[2] +'px'}"></div>
              <div class="bottom">
                <div class="value"><span class="small">￥</span> {{commission.freeze_commission}}</div>
                <div class="label">冻结中</div>
              </div>
            </div>
          </div>
          <div class="item info">
            <div class="content">
              <div class="process "  :style="{height: commissionRateHeight[3] +'px'}"></div>
              <div class="bottom">
                <div class="value"><span class="small">￥</span> {{commission.withdraw_commission}}</div>
                <div class="label">已提现</div>
              </div>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="10">
        <div class="item-title fixed">
          我的收款账户
         
        </div>
        <div class="account-item">
          <div class="icon wechat">
            <a-icon type="wechat"></a-icon>
          </div>
          <div class="info" v-if="account.wechat_name">
            <div>{{account.wechat_name}}</div>
            <div>{{account.wechat_account}}</div>
          </div>
          <div class="info empty" v-else @click="showAccountModal('wechat')">
            填写微信账户
          </div>
        </div>
        <div class="account-item">
          <div class="icon alipay">
            <a-icon type="alipay"></a-icon>
          </div>
          <div class="info" v-if="account.alipay_name">
            <div>{{account.alipay_name}}</div>
            <div>{{account.alipay_account}}</div>
          </div>
          <div class="info empty" v-else @click="showAccountModal('alipay')">
            填写支付宝账户
          </div>
        </div>
        <div class="account-item">
          <div class="icon card">
            <a-icon type="credit-card"></a-icon>
          </div>
          <div class="info card" v-if="account.bank">
            <div>{{account.bank}} {{account.bank_name}}</div>
            <div>{{account.bank_account}}</div>
          </div>
          <div class="info empty" v-else @click="showAccountModal('bank')">
            填写银行卡账户
          </div>
        </div>
        <div class="account-item">
          <div class="icon paypal">
            <i><svg t="1647000267923" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1641" width="1em" height="1em" fill="currentColor"><path d="M941.129143 369.152q10.313143 47.981714-2.267429 116.589714-49.737143 253.732571-322.852571 253.732571l-25.161143 0q-14.262857 0-25.161143 9.435429t-13.677714 24.283429l-2.267429 10.825143-31.451429 197.705143-1.170286 8.557714q-2.852571 14.848-13.970286 24.283429t-25.453714 9.435429l-143.433143 0q-11.995429 0-18.870857-8.557714t-5.12-20.553143q5.12-32.036571 15.140571-96.036571t15.140571-96.036571 15.433143-95.744 15.433143-95.744q2.852571-21.138286 24.576-21.138286l74.825143 0q75.995429 1.170286 134.875429-11.995429 99.986286-22.308571 163.986286-82.285714 58.294857-54.272 88.576-140.580571 13.677714-40.009143 19.968-75.995429 0.585143-3.437714 1.462857-4.315429t1.974857-0.585143 3.437714 1.974857q45.129143 33.718857 56.027429 92.598857zM842.825143 208.018286q0 61.147429-26.258286 134.875429-45.714286 133.12-172.544 180.004571-64.585143 22.820571-144.018286 23.990857 0 0.585143-51.419429 0.585143l-51.419429-0.585143q-57.124571 0-67.437714 54.857143-1.170286 4.534857-48.566857 302.884571-0.585143 5.705143-6.875429 5.705143l-168.594286 0q-12.580571 0-20.845714-9.435429t-6.582857-22.016l132.534857-840.557714q2.852571-16.603429 15.725714-27.428571t29.403429-10.825143l341.723429 0q19.456 0 55.734857 7.460571t63.707429 18.285714q61.147429 23.405714 93.403429 70.290286t32.256 111.981714z" p-id="1642"></path></svg></i>
          </div>
          <div class="info paypal" v-if="account.paypal">
            <div>{{account.paypal}}</div>
          </div>
          <div class="info empty" v-else @click="showAccountModal('paypal')">
            填写paypal账户
          </div>
        </div>
      </a-col>
    </a-row>
    <div class="withdraw-box">
      <div class="item-title">提现记录</div>
      <a-table :columns="columns" :data-source="logs.data" size="middle" row-key="updated_at" :pagination="false" class="transpanret-table">
        <span slot="account" slot-scope="record">
          {{record.account.type}}：{{record.account.type == '银行卡' ? record.account.bank : ''}} {{record.account.name}} {{record.account.account}} 
        </span>
        <span slot-scope="record" slot="status">
          <a-tag color="orange" v-if="record.status == 0">处理中</a-tag>
          <a-tag color="green" v-if="record.status == 1">已提现</a-tag>
          <div v-if="record.status == -1">
            <a-tag color="red" >已驳回</a-tag>
            <div class="remark">{{record.remark}}</div>
          </div>
        </span>
      </a-table>
      <div class="page-box">
        <a-pagination :total="logs.total" v-model="page" @change="getLogs" :page-size="15" size="small" />
      </div>
    </div>

    <a-modal v-model="accountVisible" title="收款账户" width="400px" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered>
      <template  slot="closeIcon">
        <a-icon type="close-circle" theme="filled"/>
      </template>
      <template slot="footer">
        <a-button key="submit" type="primary"  @click="accountConfirmVisible = true" shape="round">
          保存账户
        </a-button>
      </template>
      <div class="white-wrap">
        <div class="account-form-item alipay" v-if="accountEditType == 'alipay'">
          <div class="title"><a-icon type="alipay"></a-icon></div>
          <div class="body">
            <input type="text" class="m-input" v-model="accountForm.alipay_name" :disabled="!!account.alipay_name" placeholder="请输入支付宝姓名">
            <input type="text" class="m-input" v-model="accountForm.alipay_account" :disabled="!!account.alipay_name" placeholder="请输入支付宝账户/手机号">
          </div>
        </div>
        <div class="account-form-item wechat" v-if="accountEditType == 'wechat'">
          <div class="title"><a-icon type="wechat"></a-icon></div>
          <div class="body">
            <input type="text" class="m-input" v-model="accountForm.wechat_name" :disabled="!!account.wechat_name" placeholder="请输入姓名">
            <input type="text" class="m-input" v-model="accountForm.wechat_account" :disabled="!!account.wechat_name" placeholder="请输入微信绑定的手机号">
          </div>
        </div>
        <div class="account-form-item card" v-if="accountEditType == 'bank'">
          <div class="title"><a-icon type="credit-card"></a-icon></div>
          <div class="body">
            <a-row :gutter="16">
              <a-col :span="12">
                <input type="text" class="m-input" v-model="accountForm.bank" :disabled="!!account.bank" placeholder="请输入银行名称">
              </a-col>
              <a-col :span="12">
                <input type="text" class="m-input" v-model="accountForm.bank_name" :disabled="!!account.bank" placeholder="请输入持卡人姓名">
              </a-col>
            </a-row>
            <input type="text" class="m-input" v-model="accountForm.bank_account" :disabled="!!account.bank" placeholder="请输入银行卡号">
          </div>
        </div>
        <div class="account-form-item paypal" v-if="accountEditType == 'paypal'">
          <div class="title">
           <i><svg t="1647000267923" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1641" width="1em" height="1em" fill="currentColor"><path d="M941.129143 369.152q10.313143 47.981714-2.267429 116.589714-49.737143 253.732571-322.852571 253.732571l-25.161143 0q-14.262857 0-25.161143 9.435429t-13.677714 24.283429l-2.267429 10.825143-31.451429 197.705143-1.170286 8.557714q-2.852571 14.848-13.970286 24.283429t-25.453714 9.435429l-143.433143 0q-11.995429 0-18.870857-8.557714t-5.12-20.553143q5.12-32.036571 15.140571-96.036571t15.140571-96.036571 15.433143-95.744 15.433143-95.744q2.852571-21.138286 24.576-21.138286l74.825143 0q75.995429 1.170286 134.875429-11.995429 99.986286-22.308571 163.986286-82.285714 58.294857-54.272 88.576-140.580571 13.677714-40.009143 19.968-75.995429 0.585143-3.437714 1.462857-4.315429t1.974857-0.585143 3.437714 1.974857q45.129143 33.718857 56.027429 92.598857zM842.825143 208.018286q0 61.147429-26.258286 134.875429-45.714286 133.12-172.544 180.004571-64.585143 22.820571-144.018286 23.990857 0 0.585143-51.419429 0.585143l-51.419429-0.585143q-57.124571 0-67.437714 54.857143-1.170286 4.534857-48.566857 302.884571-0.585143 5.705143-6.875429 5.705143l-168.594286 0q-12.580571 0-20.845714-9.435429t-6.582857-22.016l132.534857-840.557714q2.852571-16.603429 15.725714-27.428571t29.403429-10.825143l341.723429 0q19.456 0 55.734857 7.460571t63.707429 18.285714q61.147429 23.405714 93.403429 70.290286t32.256 111.981714z" p-id="1642"></path></svg></i>
          </div>
          <div class="body">
            <input type="text" class="m-input" v-model="accountForm.paypal" :disabled="!!account.paypal" placeholder="请输入paypal账户">
          </div>
        </div>
        <div class="confirm-tips">
          请确认您的账户信息，为了您的账户安全，保存后将无法主动修改！
        </div>
      </div>
    </a-modal>

    <a-modal v-model="withdrawVisible" title="提现申请" width="400px" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered>
      <template  slot="closeIcon">
        <a-icon type="close-circle" theme="filled"/>
      </template>
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="loading" @click="saveApply" shape="round">
          提交申请
        </a-button>
      </template>
      <div class="white-wrap">
        <div class="current-commission">
          <div class="value"><span class="small">￥</span>{{commission.commission}}</div>
          <div class="label">当前可提现金额</div>
        </div>
        <a-form-item label="选择收款账户">
          <div class="account-select">
            <div class="option alipay" :class="{active:withdrawForm.type == 'alipay'}" @click="selectAccount('alipay')" v-if="account.alipay_name">
              <div class="icon">
                <a-icon type="alipay"></a-icon>
              </div>
              <div class="value">
                <div>{{account.alipay_name}}</div>
                <div>{{account.alipay_account}}</div>
              </div>
            </div>
            <div class="option wechat" :class="{active:withdrawForm.type == 'wechat'}"  @click="selectAccount('wechat')" v-if="account.wechat_name">
              <div class="icon">
                <a-icon type="wechat"></a-icon>
              </div>
              <div class="value">
                <div>{{account.wechat_name}}</div>
                <div>{{account.wechat_account}}</div>
              </div>
            </div>
            <div class="option card" :class="{active:withdrawForm.type == 'bank'}"  @click="selectAccount('bank')" v-if="account.bank">
              <div class="icon">
                <a-icon type="credit-card"></a-icon>
              </div>
              <div class="value">
                <div>{{account.bank}} {{account.bank_name}}</div>
                <div>{{account.bank_account}}</div>
              </div>
            </div>
            <div class="option paypal" :class="{active:withdrawForm.type == 'paypal'}"  @click="selectAccount('paypal')" v-if="account.paypal">
              <div class="icon">
                <i><svg t="1647000267923" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1641" width="1em" height="1em" fill="currentColor"><path d="M941.129143 369.152q10.313143 47.981714-2.267429 116.589714-49.737143 253.732571-322.852571 253.732571l-25.161143 0q-14.262857 0-25.161143 9.435429t-13.677714 24.283429l-2.267429 10.825143-31.451429 197.705143-1.170286 8.557714q-2.852571 14.848-13.970286 24.283429t-25.453714 9.435429l-143.433143 0q-11.995429 0-18.870857-8.557714t-5.12-20.553143q5.12-32.036571 15.140571-96.036571t15.140571-96.036571 15.433143-95.744 15.433143-95.744q2.852571-21.138286 24.576-21.138286l74.825143 0q75.995429 1.170286 134.875429-11.995429 99.986286-22.308571 163.986286-82.285714 58.294857-54.272 88.576-140.580571 13.677714-40.009143 19.968-75.995429 0.585143-3.437714 1.462857-4.315429t1.974857-0.585143 3.437714 1.974857q45.129143 33.718857 56.027429 92.598857zM842.825143 208.018286q0 61.147429-26.258286 134.875429-45.714286 133.12-172.544 180.004571-64.585143 22.820571-144.018286 23.990857 0 0.585143-51.419429 0.585143l-51.419429-0.585143q-57.124571 0-67.437714 54.857143-1.170286 4.534857-48.566857 302.884571-0.585143 5.705143-6.875429 5.705143l-168.594286 0q-12.580571 0-20.845714-9.435429t-6.582857-22.016l132.534857-840.557714q2.852571-16.603429 15.725714-27.428571t29.403429-10.825143l341.723429 0q19.456 0 55.734857 7.460571t63.707429 18.285714q61.147429 23.405714 93.403429 70.290286t32.256 111.981714z" p-id="1642"></path></svg></i>
              </div>
              <div class="value">
                <div>{{account.paypal}}</div>
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="输入提现金额">
          <a-input-number class="w100p" size="large" v-model="withdrawForm.amount" :min="50" @change="inputAmount"></a-input-number>
        </a-form-item>
        <div class="local-tip" v-if="withdrawForm.type == 'paypal'">{{localAmountTips}}</div>
        <div class="rule">
          <div class="title">提现须知：</div>
          <div>1、每次最低 提现金额需大于<a-tag color="red">50元</a-tag>。</div>
          <div>2、只有当上一次提现申请完成后才能再次申请。</div>
          <div>3、申请提现后，提现金额将会被冻结直到申请被处理。</div>
          <div>4、使用 Paypal 提现时需要向 Paypal支付手续费(通常费用：4.4%+$0.3)具体请参考 Paypal 收费标准；该手续费由Paypal收取，我们不收手续费。</div>
        </div>
        
      </div>  
    </a-modal>
    <a-modal v-model="accountConfirmVisible" :title="null" :closable="false" width="330px" centered>
        <template slot="footer">
          <a-button type="primary" :loading="loading" @click="accountConfirmVisible = false" shape="round">
            返回
          </a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="saveAccount" shape="round">
            确认
          </a-button>
      </template>
      <div class="white-wrap">
        <div>请再次确认您填写的账户是否准确！</div>

        <div class="confirm-account-item" v-if="accountEditType == 'alipay'">
          <a-icon type="alipay"></a-icon>
          {{accountForm.alipay_name}} {{accountForm.alipay_account}} 
        </div>
        <div class="confirm-account-item" v-if="accountEditType == 'wechat'">
          <a-icon type="wechat"></a-icon>
          {{accountForm.wechat_name}} {{accountForm.wechat_account}} 
        </div>
        <div class="confirm-account-item"  v-if="accountEditType == 'bank'">
          <a-icon type="credit-card"></a-icon>
          {{accountForm.bank}} {{accountForm.bank_name}} {{accountForm.bank_account}} 
        </div>
         <div class="confirm-account-item"  v-if="accountEditType == 'paypal'">
          <i><svg t="1647000267923" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1641" width="1em" height="1em" fill="currentColor"><path d="M941.129143 369.152q10.313143 47.981714-2.267429 116.589714-49.737143 253.732571-322.852571 253.732571l-25.161143 0q-14.262857 0-25.161143 9.435429t-13.677714 24.283429l-2.267429 10.825143-31.451429 197.705143-1.170286 8.557714q-2.852571 14.848-13.970286 24.283429t-25.453714 9.435429l-143.433143 0q-11.995429 0-18.870857-8.557714t-5.12-20.553143q5.12-32.036571 15.140571-96.036571t15.140571-96.036571 15.433143-95.744 15.433143-95.744q2.852571-21.138286 24.576-21.138286l74.825143 0q75.995429 1.170286 134.875429-11.995429 99.986286-22.308571 163.986286-82.285714 58.294857-54.272 88.576-140.580571 13.677714-40.009143 19.968-75.995429 0.585143-3.437714 1.462857-4.315429t1.974857-0.585143 3.437714 1.974857q45.129143 33.718857 56.027429 92.598857zM842.825143 208.018286q0 61.147429-26.258286 134.875429-45.714286 133.12-172.544 180.004571-64.585143 22.820571-144.018286 23.990857 0 0.585143-51.419429 0.585143l-51.419429-0.585143q-57.124571 0-67.437714 54.857143-1.170286 4.534857-48.566857 302.884571-0.585143 5.705143-6.875429 5.705143l-168.594286 0q-12.580571 0-20.845714-9.435429t-6.582857-22.016l132.534857-840.557714q2.852571-16.603429 15.725714-27.428571t29.403429-10.825143l341.723429 0q19.456 0 55.734857 7.460571t63.707429 18.285714q61.147429 23.405714 93.403429 70.290286t32.256 111.981714z" p-id="1642"></path></svg></i>
          {{accountForm.paypal}} 
        </div>
      </div>
    </a-modal>
    
  </div>
</template>

<script>
const columns = [
  {
    title: '日期',
    dataIndex:'updated_at'
  },
  {
    title: '提现金额',
    dataIndex:'amount'
  },
  {
    title: '提现前金额',
    dataIndex:'before_amount'
  },
  {
    title: '提现后金额',
    dataIndex:'after_amount'
  },
  {
    title: '收款账户',
    scopedSlots: { customRender: 'account' },
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
  },
];
let self;
export default {
  name: '',
  data(){
    return {
      columns,
      accountVisible:false,
      accountConfirmVisible:false,
      loading:false,
      accountEditType:'',
      accountForm:{},
      account:{},
      withdrawVisible:false,
      withdrawForm:{},
      page:1,
      logs:{},
      commission:{},
      commissionRateHeight:[0,0,0,0],
      localAmountTips:""
    }
  },
  mounted(){
    self = this;
    self.getCommission();
    self.getAccount();
    self.getLogs();
  },
  methods:{
    getAccount(){
      this.$http.get('getAccount').then((res)=>{
        this.account = res.data || {};
      });
    },
    getCommission(){
      this.$http.get('getCommission').then((res)=>{
        this.commission = res.data;
        let info = res.data;
        this.commissionRateHeight[0] = 200;
        this.commissionRateHeight[1] = info.total_commission ? (info.commission / info.total_commission) * 200 : 0;
        this.commissionRateHeight[2] = info.total_commission ? (info.freeze_commission / info.total_commission) * 200 : 0;
        this.commissionRateHeight[3] = info.total_commission ? (info.withdraw_commission / info.total_commission) * 200 : 0;
      });
    },
    getLogs(){
      let params = {
        page : this.page
      };
      this.$http.get('listWithdrawLogs',{params}).then((res)=>{
        this.logs = res.data;
      });
    },
    showAccountModal(type){
      this.accountEditType = type;
      this.accountForm = {...this.account, type};
      this.accountVisible = true;
    },
    saveAccount(){
      this.$http.post('saveAccount', this.accountForm).then((res)=>{
        self.$message.success(res.msg)
        self.accountVisible = false;
        self.accountConfirmVisible = false;
        self.getAccount();
        self.$store.commit('setAccount', res.data)
      });
    },
    showWithdrawModal(){
      if(!this.account.id){
        this.$message.error('请先填写收款账户');
        return;
      }
      let type = '';
      if(this.account.wechat_name){
        type = 'wechat';
      }else if(this.account.alipay_name){
        type = 'alipay';
      }else if(this.account.bank_name){
        type = 'bank';
      }
      if(!type){
        this.$message.error('请先填写收款账户');
        return;
      }
      if(this.commission.commission <= 0){
        this.$message.error('您当前没有可提现金额！');
        return;
      }
      this.withdrawForm = {
        type:type,
        amount:this.commission.commission
      };
      this.withdrawVisible = true;
    },
    selectAccount(type){
      this.withdrawForm = {...this.withdrawForm, type};
      this.inputAmount();
    },
    inputAmount(){
      console.log("ss");
      this.calcLocalAmount("paypal", this.withdrawForm.amount);
    },
    calcLocalAmount(payment, amount){
      this.$http.post('calcLocalAmount', {payment, amount}).then((res)=>{
        self.localAmountTips = res.data.tips
      });
    },
    saveApply(){
      this.$http.post('applyWithdraw', this.withdrawForm).then((res)=>{
        self.$message.success(res.msg)
        self.withdrawVisible = false;
        self.page = 1;
        self.getLogs();
        self.getCommission();
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../assets/reset.less';
  
  .m-input::placeholder{
    color: rgba(0, 0, 0, 0.3);
  }
  .m-input{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    height: 45px;
    padding: 4px 11px;
    font-size: 14px;
    line-height: 1.5;
    background-image: none;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 0;
    transition: all 0.3s;
    text-align: center;
    -webkit-appearance: none;
    outline: none;
  }
  .m-input:focus{
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  }
  .current-commission{
    text-align: center;
    padding-bottom: 40px;
  }
  .current-commission .label{
    font-size: 12px;
  }
  .current-commission .value{
    font-size: 42px;
    color: rgb(0, 172, 28);
    font-weight: 500;
  }
  .account-select .option{
    display: flex;
    padding: 1rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
  }
  .account-select .option:hover{
    color: rgba(122, 61, 252, 0.8)
  }
  .account-select .option::after{
    content: '';
    display:block;
    position: absolute;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.04);
    top: 28px;
    right: 0;
  }
  .account-select .option.active::after{
    border: 5px solid rgba(0, 172, 28, 1);
    background: #fff;
  }
  .account-select .option .icon{
    height: 40px;
    width: 40px;
    
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 18px;
  }
  .account-select .option.wechat .icon{
    background: rgb(0, 172, 28);
  }
  .account-select .option.alipay .icon{
    background: rgb(31, 148, 250);
  }
  .account-select .option.card .icon{
    background: rgb(5, 121, 138);
  }
  .account-select .option.paypal .icon{
    background: rgb(0, 156, 222);
  }
  .account-select .option .value{
    line-height: 20px;
  }
  .account-select .option.paypal .value{
    line-height: 40px;
  }
  .rule{
    background: rgba(0, 0, 0, 0.05);
    color: #777;
    padding: 10px;
    border-radius: 5px;
    margin: 20px 0;
    font-size: 12px;
    line-height: 20px;
  }
  .rule .title{
    font-size: 14px;
    color: #111;
    margin-bottom: 10px;
  }
  .account-form-item{
     margin-bottom: 20px;
     overflow: hidden;
     border-radius: 5px;
  }
  .account-form-item .title{
    padding: 10px;
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }
  .account-form-item .body{
    padding: 1rem;
  }
  .account-form-item.wechat{
    box-shadow: 0 0 0 5px rgba(0, 172, 28,0.3);
  }
  .account-form-item.alipay{
    box-shadow: 0 0 0 5px rgba(31, 148, 250,0.3);
  }
  .account-form-item.card{
    box-shadow: 0 0 0 5px rgba(5, 121, 138,0.38);
    margin-bottom: 0;
  }
  .account-form-item.paypal{
    box-shadow: 0 0 0 5px rgba(0, 156, 222,0.38);
    margin-bottom: 0;
  }
  .account-form-item.wechat .title{
    background: rgba(0, 172, 28,0.8);
  }
  .account-form-item.alipay .title{
    background:  rgba(31, 148, 250,0.8);
  }
  .account-form-item.card .title{
    background: rgba(5, 121, 138,0.8);
  }
  .account-form-item.paypal .title{
    background: rgba(0, 156, 222,0.8);
  }

 .item-title{
    color: #fff;
    margin-bottom: 1rem;
  }
  .stat-box{
    display: flex;
  }
  .stat-box .item{
    flex: 1;
    text-align: center;
    position: relative;
    height: 200px;
  }
  .stat-box .item .content{
    display: inline-block;
    background: #26273b;
    border-radius: 35px;
    padding: 1rem;
    text-align: center;
    height: 100%;
    width: 60%;
    position: relative;
    overflow: hidden;
    
  }
  .stat-box .item.primary .content{
    box-shadow: 0 8px 25px rgba(122, 61, 252, 0.8);
  }
  
  .stat-box .item .bottom{
    position: absolute;
    bottom: 1rem;
    left: 0;
    width: 100%;
    color: #fff;
  }
  .stat-box .item .label{
    font-size: 12px;
  }
  .stat-box .item .value{
    font-size: 16px;
    font-family: cursive;
  }
  .stat-box .item .process{
    background: @primary-color;
    position: absolute;
    height: 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    transition: all 0.3s;
  }
  .stat-box .item.success .process{
    background: @success-color;
  }
  .stat-box .item.info .process{
    background: @info-color;
  }
  .stat-box .item.warning .process{
    background: @warning-color;
  }
  .stat-box .item.error .process{
    background: @error-color;
  }

  .account-item{
    padding-bottom: 10px;
    display: flex;
  }
  .account-item .icon{
    background: @primary-color;
    text-align: center;
    border-radius: 10px;
    font-size: 20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
    color: #fff;
  }
  .account-item .icon.alipay{
    background: rgb(31, 148, 250);
    box-shadow: 0 3px 10px rgba(31, 148, 250,0.8);
  }
  .account-item .icon.wechat{
    background: rgb(0, 172, 28);
    box-shadow: 0 3px 10px rgba(0, 172, 28,0.8);
  }
  .account-item .icon.card{
    background: rgb(5, 121, 138);
    box-shadow: 0 3px 10px rgba(5, 121, 138,0.8);
  }
   .account-item .icon.paypal{
    background: rgb(0, 156, 222);
    box-shadow: 0 3px 10px rgba(0, 156, 222,0.8);
  }
  .account-item .info{
    flex: 5;
    color: rgba(255, 255, 255, 0.8);
    line-height: 20px;
  }
  .account-item .info.paypal{
     line-height: 40px;
   }

   .account-item .info.empty{
     line-height: 40px;
     color: rgba(255, 255, 255, 0.5);
     text-align: center;
     border: 1px dashed rgba(255, 255, 255, 0.3);
     cursor: pointer;
   }
   .account-item .info.empty:hover{
     color: #fff;
   }

  .withdraw-box{
    margin-top: 60px;
  }

  .page-box{
    text-align: right;
    margin-top: 20px;
  }

  .confirm-tips{
    background: rgba(0, 0, 0, 0.04);
    padding: 10px;
    font-size: 12px;
    border-radius: 5px;
    margin-top: 20px;
  }
  .confirm-account-item{
    padding: 1rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }
  .confirm-account-item:last-child{
    border-bottom: none;
  }

  .remark{
    font-size: 12px;
    margin-top: 10px;
    width: 200px;
  }

  .local-tip{
    background: rgba(255, 21, 21, 0.1);
    padding: 10px;
    border-radius: 5px;
    color: #f00;
    font-size: 12px;
  }
</style>
